
import React from 'react';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import CTAButton from '@/components/CTAButton';
import { useBreakpoint } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';

const GeniusCardHero = () => {
  const { isMobile } = useBreakpoint();
  
  return (
    <section className="">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl">
        <div className="text-center space-y-8 md:space-y-12">
          
          {/* Enhanced Logo */}
          <div className="flex justify-center mb-6 md:mb-8 relative">
            {/* Magical glow background */}
            <div className="absolute inset-0 -z-10">
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-gradient-to-r from-[#003a70]/20 to-[#FEE6D8]/30 rounded-full blur-2xl animate-pulse"></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-gradient-to-r from-[#FEE6D8]/40 to-[#003a70]/20 rounded-full blur-xl animate-float"></div>
            </div>
            
            {/* Logo container with enhanced styling */}
            <div className="relative group">
              {/* Subtle border glow */}
              <div className="absolute inset-0 bg-gradient-to-r from-[#003a70]/30 to-[#FEE6D8]/30 rounded-3xl blur-sm group-hover:blur-md transition-all duration-300 opacity-0 group-hover:opacity-100"></div>
              
              {/* Main logo */}
              <div className="relative bg-white/80 backdrop-blur-sm rounded-3xl p-6 md:p-8 border border-white/40 shadow-2xl group-hover:shadow-3xl transition-all duration-300 group-hover:scale-105">
                <img 
                  src="/lovable-uploads/57e84cc7-66d2-4ad1-8d3e-fb962a396635.png" 
                  alt="The Genius Card Playbook" 
                  className={cn(
                    "max-w-full h-auto filter drop-shadow-lg group-hover:drop-shadow-xl transition-all duration-300 rounded-2xl", 
                    isMobile ? "max-h-32" : "max-h-40"
                  )} 
                />
                
                {/* Sparkle effects */}
                <div className="absolute top-2 right-2 w-2 h-2 bg-[#FEE6D8] rounded-full animate-ping opacity-75"></div>
                <div className="absolute top-1/2 right-1 w-1 h-1 bg-[#FEE6D8] rounded-full animate-ping delay-300"></div>
              </div>
            </div>
          </div>

          {/* Bold Headline */}
          <div className="space-y-4">
            <h1 className={cn(
              "font-bold text-[#003a70] leading-tight", 
              isMobile ? "text-3xl md:text-5xl" : "text-5xl lg:text-6xl"
            )}>
              Master the Art of AI-Powered
              <br />
              <span className="text-[#003a70]">
                Business Genius
              </span>
            </h1>
          </div>

          {/* Loom Video */}
          <div className="max-w-4xl mx-auto">
            <AspectRatio ratio={16 / 9} className="rounded-xl overflow-hidden shadow-2xl">
              <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                <iframe 
                  src="https://www.loom.com/embed/894820d634e8405791b94d9ed573d2fe?sid=875e26a3-fd1f-4792-bcdd-3fda9613641b&hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true" 
                  frameBorder="0" 
                  allowFullScreen
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                />
              </div>
            </AspectRatio>
          </div>

          {/* CTA Button */}
          <div className="pt-4">
            <CTAButton 
              variant="primary"
              to="https://cart.deliciousmarketing.io/genius-card-playbook/?coupon=GENIUS-LAUNCH"
              className={cn(
                "font-bold shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300", 
                isMobile ? "text-lg px-8 py-4" : "text-xl px-12 py-5"
              )}
            >
              Get Instant Access Now
            </CTAButton>
          </div>

        </div>
      </div>

      {/* Background Decorations */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute top-1/4 left-10 w-72 h-72 bg-[#FEE6D8]/30 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-1/4 right-10 w-96 h-96 bg-[#003a70]/10 rounded-full blur-3xl animate-float" style={{
          animationDelay: '2s'
        }}></div>
      </div>
    </section>
  );
};

export default GeniusCardHero;
